import Icon from "@hudson/ui/components/Icon";
import { motion } from "framer-motion";
import useContent from "@lib/use_content";

function NoReservations(): JSX.Element | null {
  const { data, loading, error } = useContent([
    "beProfileResNoResMessage",
    "beProfileResNoResMessageTitle",
  ]);

  if (error) console.error(error);
  if (error || loading) return null;

  return (
    <motion.div
      style={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="max-w-2xl mx-auto py-6 px-4 sm:py-2 sm:px-6 lg:px-8"
    >
      <div className="xs:flex">
        <div className="hidden xs:block mb-4 shrink-0 sm:mb-0 mr-6">
          <motion.div
            style={{ rotate: -25, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            transition={{
              type: "tween",
              ease: "easeOut",
              duration: 0.5,
            }}
          >
            <Icon
              type="info"
              className="h-12 w-12 sm:h-20 sm:w-20 opacity-80"
              secondaryColor="white"
            />
          </motion.div>
        </div>
        <div>
          <h4 className="text-2xl font-extrabold tracking-tight text-gray-900">
            {data?.content.beProfileResNoResMessageTitle}
          </h4>
          <p
            className="mt-1 prose prose-base sm:prose-base"
            dangerouslySetInnerHTML={{
              __html: data?.content.beProfileResNoResMessage || "",
            }}
          ></p>
        </div>
      </div>
    </motion.div>
  );
}

export default NoReservations;
